  function toggleMobile() {
	var x = document.getElementById("navbar-nav-mobile");
	var a = document.getElementById("navbar-toggler-top");
	var b = document.getElementById("navbar-toggler-middleA");
	var c = document.getElementById("navbar-toggler-middleB");
	var d = document.getElementById("navbar-toggler-bottom");
	if (x.style.display === "block") {
	  x.style.display = "none";
	  a.classList.remove("toggle-hide");
	  b.classList.remove("toggle-rotated");
	  c.classList.remove("toggle-rotated");
	  d.classList.remove("toggle-hide");
	} else {
	  x.style.display = "block";
	  a.classList.add("toggle-hide");
	  b.classList.add("toggle-rotated");
	  c.classList.add("toggle-rotated");
	  d.classList.add("toggle-hide");
	}
  } 

function myFunction(n) {
	var x = document.getElementById("navbar-nav-mobile");
	var a = document.getElementById("navbar-toggler-top");
	var b = document.getElementById("navbar-toggler-middleA");
	var c = document.getElementById("navbar-toggler-middleB");
	var d = document.getElementById("navbar-toggler-bottom");
	if (n.matches) { // If media query matches
	  x.style.display = "none";
	  a.classList.remove("toggle-hide");
	  b.classList.remove("toggle-rotated");
	  c.classList.remove("toggle-rotated");
	  d.classList.remove("toggle-hide");
    }
  }

  var n = window.matchMedia("(min-width: 992px)")
  myFunction(n) // Call listener function at run time
  n.addListener(myFunction) // Attach listener function on state changes

$(document).ready(function() {
	var slider = $('#press-slider-content').lightSlider({
	  item:1,
	  slideMargin:0,
	  loop:true,
	  auto:true,
	  pause:8000,
	  controls:false,
	  pager:true,
	  keyPress:true
	});
var slider = $('#testimonials-slider-content').lightSlider({
	  item:1,
	  slideMargin:0,
	  loop:true,
	  auto:true,
	  pause:8000,
	  controls:false,
	  pager:false,
	  keyPress:true
	});
  

  	var slider = $('#featureB-slider-content').lightSlider({
	  item:1.35,
	  slideMargin:100,
	  loop:true,
	  auto:true,
	  pause:8000,
	  controls:false,
	  pager:false,
	  keyPress:true,
	  responsive: [
		  {
			  breakpoint:752,
			  settings: {
				  item:1.2,
	  			  slideMargin:7
				}
		  }
	  ]
	});

    //$(document).ready(function() {
	var slider = $('#ourstory-slider-content').lightSlider({
	  item:1.35,
	  slideMargin:100,
	  loop:true,
	  auto:true,
	  pause:8000,
	  pager:true,
	  controls:false,
	  pager:false,
	  keyPress:true,
	  centerSlide:false,
	  responsive: [
		  {
			  breakpoint:752,
			  settings: {
				  item:1.2,
	  			  slideMargin:7,
	  			  centerSlide:true,
				}
		  }
	  ]
	});
 // });

   //$(document).ready(function() {
	var slider = $('#testimonials-slider-content').lightSlider({
	  item:1,
	  slideMargin:0,
	  loop:true,
	  auto:true,
	  pause:8000,
	  controls:false,
	  pager:true,
	  keyPress:true
	});

    //$(document).ready(function() {
	// var slider = $('.product-slider').lightSlider({
 //      gallery:true,
 //      item:1,
 //      vertical:true,
 //      verticalHeight:800,
 //      vThumbWidth:120,
 //      thumbItem:10,
	//   thumbsLeft:true,
 //      thumbMargin:20,
 //      slideMargin:0,
	//   galleryMargin:20,
	//   responsive : [
	// 	  {
	// 		  breakpoint:1180,
	// 		  settings: {
	// 			  vThumbWidth:90
	// 		  }
	// 	  }, 
 //          {
 //              breakpoint:760,
 //              settings: {
 //                  vThumbWidth:70,
 //      			  thumbMargin:8,
	//  			  galleryMargin:8
 //              }
 //          }
	//   ]
	// });
 // });
  //});


  /* sticky sidebar */
    var $sidebar = $('.product_main_wrapper .product__info-wrapper');
    var blogHeight = $('.left-pane').outerHeight() ;
    $(window).scroll(fixSidebarOnScroll);
    function fixSidebarOnScroll() {
      //console.log(blogHeight);
        var windowScrollTop = $(window).scrollTop();
        if (windowScrollTop >= blogHeight) {
            $sidebar.removeClass('fixed');
            $sidebar.addClass('absolute');
            $('.product_main_wrapper .product__info-wrapper').css("top", blogHeight);
        }
        else if (windowScrollTop >= 1) {
            if (!$sidebar.hasClass('fixed')) {
                $sidebar.addClass('fixed');
                $sidebar.removeClass('absolute');
                $('.product_main_wrapper .product__info-wrapper').css("top", "138px");
            }
        }
    }
  });


// product main page slider 
// $(document).ready(function() {
// $('.gallery-slider-for').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   // infinite: true,
//   vertical: true,
//   asNavFor: '.gallery-slider-nav',
//   slide: '.__maininslider',
//   // fade: true,
//   responsive: [
//     {
//       breakpoint: 991,
//       settings: {
//       slidesToShow: 1,
//       vertical: false,   
//       centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
//       slidesToScroll: 1,
//       fade: false,
//       }
//     }
//    ]
// });
  
// $('.gallery-slider-nav').slick({
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   asNavFor: '.gallery-slider-for',
//   dots: false,
//   vertical: true,
//   focusOnSelect: true,
//   // infinite: true,
//   slide: '.__thumbinslider'
// });
  
// $("body").on("click", ".for-slick-use", function(e) {
//    $('.slick-next').trigger("click");
//   //  var imageSrc = $(".for-slick-use:checked").attr('data-image-src');
//   // console.log(imageSrc);
//   // //$('.product__media.media img').attr('srcset',imageSrc);
//   // var imageMainSlider = $(".slick-current .product__media img").attr('src');
//   // var slicedImageUrl = imageMainSlider.split('&')[0];
//   // console.log(slicedImageUrl);
//   // if(imageSrc !== slicedImageUrl){
//   //   console.log("Not equal");
//   //   $('.product__media.media img').attr('srcset',imageSrc);
//   // }
//   });
//   // $(".gallery-slider-for").on("afterChange", function (){
//   //   var imageMainSlider = $(".slick-active .product__media img").attr('src');
//   //       $('.product__media.media img').attr('srcset',imageMainSlider);
//   //   });

// });




// end product main page slider 

// header nav mobile view

$(".nav-link").on("click", function(){
  $(".nav-link").siblings().removeClass("show-menu");
  $(this).siblings().addClass("show-menu");
})


// filter hide/show on collection page

function hideFilter(){
  $(".perfume-filter-toggler").fadeOut(function () {
      $(".perfume-filter-toggler").text(($(".perfume-filter-toggler").text() == 'SHOW FILTERS') ? 'HIDE FILTERS' : 'SHOW FILTERS').fadeIn();
    
      $("aside#main-collection-filters").toggle();
      $("aside#main-search-filters").toggle();
    
      $("#ProductGridContainer .product-grid .card__inner").toggleClass("filtereffect");
    
      $(".product-viewport .facets-vertical .product-grid-container").toggleClass("filtereffect");
      $(".template-search .facets-vertical .product-grid-container").toggleClass("filtereffect");
    
      $(".product-viewport").toggleClass("filtereffect");
      $(".product-viewport .facets-vertical.page-width").toggleClass("filtereffect");
      $(".template-search .facets-vertical.page-width").toggleClass("filtereffect");
      $(".product-viewport .facets-vertical-sort").toggleClass("filtereffect");
  })
}


// remove "from" from price

$("#ProductGridContainer .card__information .price-item").text(function() {
  console.log("hw")
  
    return $(this).text().replace(/(From)/g, '');
});




$("#navbar-nav-desktop .nav-item").hover(function(){
  var position = $(this).position();
  $(this).children(".megamenu-wrapper").css("padding-left", position.left);
});

$('.gift-card .customer .recipient-checkbox').click(function(){
  $(this).toggleClass('active');
})


// Portraits B Slider Settings
$(document).ready(function() {
	var slider = $('#lalalove-portraitsB-slider').lightSlider({
	  item:4.1,
	  slideMargin:20,
	  loop:false,
	  auto:false,
	  pager:false,
	  controls:false,
	  keyPress:true,
	  centerSlide:false,
	  responsive: [
		  {
			  breakpoint:976,
			  settings: {
				  item:4.15,
				}
		  }
	  ]
	});
  });

// Portraits C Slider Settings
 $(document).ready(function() {
	var slider = $('#lalalove-portraitsC-slider').lightSlider({
	  item:4.1,
	  slideMargin:20,
	  loop:false,
	  auto:false,
	  pager:false,
	  controls:false,
	  keyPress:true,
	  centerSlide:false,
	  responsive: [
		  {
			  breakpoint:976,
			  settings: {
				  item:4.15,
				}
		  }
	  ]
	});
  });




// Portrait Slide-in Text Panels (Group - LALA LOVE)
document.addEventListener("DOMContentLoaded", function() {
    function toggleMobileLa(element) {
    if (element.classList.contains("mobile-slide-show")) {
	  element.classList.remove("mobile-slide-show");
	} else {
	  element.classList.add("mobile-slide-show");
	}
  } 
var x = document.getElementsByClassName("lalalove-portrait-mobile");

    for (var i = 0; i < x.length; i++) {
       x[i].addEventListener("click", function() {
         toggleMobileLa(this);
       });
    }
  });



 $(document).ready(function() {
 $('.up-text p').each(function () {
        var lines = $(this).html().split('<br>');
        $(this).html('');

        $.each(lines, function (index, line) {
            var span = $('<span>').html(line);
            $(this).append(span);

            // Add a <br> tag after each span, except for the last one
            if (index < lines.length - 1) {
                $(this).append($('<br>'));
            }
        }.bind(this));
    });
     $('.up-text p > *').each(function (e) {
        let wrap = $(this).parent();
        let text = $(this).wrapInner('<span class="over-text-con"></span>');
        let textCon = text.find(".over-text-con");
    });
   });
$(document).on("scroll", function () {
    var pageTop = $(document).scrollTop()
    var pageBottom = pageTop + $(window).height()
    var tags = $(".up-text p span")

    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i]

      if ($(tag).offset().top < pageBottom) {
        $(tag).addClass("visible")
      } else {
        $(tag).removeClass("visible")
      }
    }
  });


$(document).ready(function() {
   let selectedVariantId = ""; // Initialize variable to store selected variant ID

  // Fetch cart drawer and count on page load
  fetchCartDrawer();
  fetchCartCount();
  
  // Event handler for changes in the custom select
$(document).on('change', '.custom-select', function() {
    // Get the selected variant ID
    selectedVariantId = $(this).val();
    console.log('Selected variant ID:', selectedVariantId);

    // Optionally, you can also get additional data attributes like the price
    const selectedOption = $(this).find('option:selected');
    const variantPrice = selectedOption.data('price');
    console.log('Selected variant price:', variantPrice); // Corrected logging
  });
  
  // Event handler for the add-to-cart button
  $(document).on('click', '.add-to-cart-button', function(e) {
    e.preventDefault(); // Prevent the default form submission  
   let nearestForm = $(this).closest('form');
    let selectedVariantId = nearestForm.find('.custom-select option:selected').val();
    
    console.log('Selected Variant ID:', selectedVariantId);
    if (selectedVariantId === null) {
      console.error('No variant selected');
      return; // Stop execution if no variant is selected
    }

    const quantity = 1;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({
        id: selectedVariantId,
        quantity: quantity
      }),
      dataType: 'json',
      contentType: 'application/json',
      success: function(response) {
        console.log('Product added to cart:', response);

        // Fetch updated cart drawer and cart count
        updateCart().then(() => {
          // Add a short delay to ensure the content is fully updated before opening the drawer
          setTimeout(function() {
            openCartDrawer(); // Open the cart drawer by adding the class 'active'

            // Focus trapping logic
            const containerToTrapFocusOn = $('.cart-drawer').hasClass('is-empty') 
              ? document.querySelector('.drawer__inner-empty') 
              : document.getElementById('CartDrawer');
              
            // You can trap the focus on the container here (if using a library for focus trapping)
            console.log('Container to trap focus on:', containerToTrapFocusOn);
          }, 200); // 200ms delay
        });
      },
      error: function(XMLHttpRequest, textStatus) {
        console.error('Error adding product to cart:', textStatus);
      }
    });
  });

  function fetchCartDrawer() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['#CartDrawer-Form', '.drawer__footer'];
        
        selectors.forEach(selector => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.innerHTML = sourceElement.innerHTML; // Update the target element
          }
        });

        // Remove classes if they exist
        const cartDrawer = document.getElementsByClassName('drawer')[0]; // Access first element
        if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }

        const drawerInnerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
        if (drawerInnerEmpty) {
          drawerInnerEmpty.classList.remove('drawer__inner-empty');
        }
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems && cartDrawerItems.classList.contains('is-empty')) {
          cartDrawerItems.classList.remove('is-empty');
        }
      })
      .catch(error => {
        console.error('Error fetching cart drawer:', error);
      });
  }

  function fetchCartCount() {
    return fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(cart => {
        const cartCountElement = $('.cart-count-bubble');
        const itemCount = cart.item_count;
        console.log('Fetched item count:', itemCount); // Debug: log item count
        cartCountElement.text(itemCount > 0 ? itemCount : '0'); // Update cart count
        // Force a reflow to ensure the count updates properly
        setTimeout(() => {
          cartCountElement.hide().show(0);
        }, 100);
      })
      .catch(error => {
        console.error('Error fetching cart count:', error);
      });
  }

  function updateCart() {
    return Promise.all([fetchCartDrawer(), fetchCartCount()]);
  }

  function openCartDrawer() {
    $('.drawer').addClass('active'); // Ensure the drawer is using the correct class
  }


//   $(document).on("click",".custom-select", function(){
//     console.log("Clicked");
//   });
// });




});

$(document).ready(function() {
    // var slider = $('#pairings-mobile').lightSlider({
    //     item: 1.5,
    //     slideMargin: 0,
    //     loop: true,
    //     auto: false,
    //     pause: 8000,
    //     controls: false,
    //     useCSS: false, 
    //     pager: false,
    //     keyPress: true,
    //     centerSlide: true,
    //     freeMove: true,
    //     enableDrag: true,
    //     enableTouch: true,
    //     cssEasing: 'linear',  
    //     swipeThreshold: 100,
    // });
  $('#pairings-mobile').slick({
    dots: false,
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    centerMode: true
  });

});


document.addEventListener('click', function(event) {
  // Check if the clicked element is an 'a' tag within a 'cart-remove-button'
  if (event.target.closest('cart-remove-button a')) {
    event.preventDefault();  // Prevent default link action
    console.log("Click"); // Logging for debugging
    
    const lineItemIndex = event.target.closest('cart-remove-button').getAttribute('data-index'); // Get the data-index
    updateCart(lineItemIndex);
  }
});

function updateCart(lineItemIndex) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: lineItemIndex, // Use line index here
      quantity: 0
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok: ' + response.statusText);
    }
    return response.json();
  })
  .then(cart => {
    renderCart(cart);  // Function to update the cart UI
    toggleEmptyClass(cart.item_count);  // Check if the cart is empty
  })
  .catch(error => console.error('Error updating cart:', error));
}

function renderCart(cart) {
  // Update your cart UI based on the new cart content
}

function toggleEmptyClass(itemCount) {
  if (itemCount === 0) {
    document.body.classList.add('cart-empty');
  } else {
    document.body.classList.remove('cart-empty');
  }
}


$('body').on('click', '[data-element="bundle-add-to-cart"]', function(event) {
    event.preventDefault();

    const prodIdMain = $('#main_product_id').val();
    if (!prodIdMain) {
        console.error("Main product not found. Cannot proceed.");
        return;
    }

    // Always include this one
    const primaryFreeSample = {
        id: $('#free_sample').val(),
        tag: $('#free_sample').attr('data-tag')
    };

    // Complimentary samples (conditionally added)
    const complimentaryProducts = [
        {
            id: $('#free_sample-1').val(),
            tag: $('#free_sample-1').attr('data-tag')
        },
        {
            id: $('#free_sample-2').val(),
            tag: $('#free_sample-2').attr('data-tag')
        },
        {
            id: $('#free_sample-3').val(),
            tag: $('#free_sample-3').attr('data-tag')
        }
    ];

    let items = [];

    $.getJSON('/cart.js', function(cart) {
        const existingProductIds = cart.items.map(item => item.id);

        //  Always add #free_sample (primary sample)
        if (primaryFreeSample.id && !existingProductIds.includes(parseInt(primaryFreeSample.id))) {
            items.push({
                quantity: 1,
                id: primaryFreeSample.id,
                properties: {
                    Type: primaryFreeSample.tag,
                    _bundle_id: prodIdMain
                }
            });
        }

        // Check if any secondary complimentary item is already in cart
        const complimentaryExists = complimentaryProducts.some(p =>
            p.id && existingProductIds.includes(parseInt(p.id))
        );

        // If none of them exist, add the secondary complimentary items
        if (!complimentaryExists) {
            complimentaryProducts.forEach(p => {
                if (p.id) {
                    items.push({
                        quantity: 1,
                        id: p.id,
                        properties: {
                            Type: p.tag,
                            _bundle_id: prodIdMain
                        }
                    });
                }
            });
        } else {
            console.log("Some complimentary products already in cart. Skipping those.");
        }

        // Add the main product if it's not already in cart
        if (!existingProductIds.includes(parseInt(prodIdMain))) {
            items.push({
                quantity: 1,
                id: prodIdMain,
                properties: {
                    _bundle_id: prodIdMain
                }
            });
        }

        if (items.length === 0) {
            console.log("Nothing new to add to the cart.");
            return;
        }

        console.log("Items to be added:", items);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { items: items },
            success: function(data) {
                console.log("Items added to cart successfully:", data);
                window.location = "/cart";
            },
            error: function(xhr) {
                console.error("Error adding to cart:", xhr.responseText);
            }
        });

    }).fail(function() {
        console.error("Error loading cart.");
    });
});










document.addEventListener('click', function (event) {
    if (event.target.matches('a.button--tertiary')) {
        event.preventDefault();
      

        const mainProductKey = event.target.getAttribute('data-line-item-key');
        if (!mainProductKey) {
            console.error("Main product key is missing.");
            return;
        }

        // Fetch the cart to find the _bundle_id
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const mainItem = cart.items.find(item => item.key === mainProductKey);

                if (!mainItem) {
                    console.error("Main item not found in cart.");
                    return;
                }

                // Check if the main product has a _bundle_id
                if (!mainItem.properties || !mainItem.properties._bundle_id) {
                    console.error("Main product does not have a _bundle_id. Skipping removal process.");
                    return;
                }

                const bundleId = mainItem.properties._bundle_id;
                console.log("Bundle ID:", bundleId);

                // Find all items in the bundle
                const bundledItems = cart.items.filter(item => 
                    item.properties && item.properties._bundle_id === bundleId
                );

                if (bundledItems.length === 0) {
                    console.error("No bundled items found for this _bundle_id.");
                    return;
                }

                console.log("Bundled Items to Remove:", bundledItems);

                // Function to remove an item and return the promise
                 function removeItem(item) {
                  const checkoutBtn = document.querySelector('.block_wrapper');
                  console.log(checkoutBtn, "checkoutBtn");
                 checkoutBtn.style.pointerEvents = 'none';
                    const body = JSON.stringify({ id: item.key, quantity: 0 });
                    console.log(`Removing item: ${item.key}, Bundle ID: ${item.properties._bundle_id}, Request Body: ${body}`);

                    return fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: body,
                    }).then(response => {
                        if (!response.ok) {
                            console.error(`Failed to remove item: ${item.key}`);
                        }
                        return response;
                    });
                }

                // Remove items one by one in sequence
                bundledItems.reduce((promise, item) => {
                    return promise.then(() => removeItem(item)); // Chain removals
                }, Promise.resolve())  // Start with a resolved promise to begin chaining
                .then(() => {
                    console.log("All bundled items removed successfully.");
                    // Reload the page to reflect changes
                  
                    location.reload();
                })
                .catch(error => {
                    console.error("Error removing items:", error);
                    location.reload();
                });
            })
            .catch(error => {
                console.error("Error fetching cart:", error);
            });
    }
});




document.addEventListener('DOMContentLoaded', function () {
    // Function to update cart quantity
    function updateCartItemQuantity(itemId, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: itemId,
                quantity: quantity,
            }),
        })
        .then(response => response.json())
        .then(cart => {
            console.log('Cart updated:', cart);
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });
    }

    // Function to check if product exists in cart
    function checkAndUpdateCart(productId) {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartItem = cart.items.find(item => item.id === productId);
                if (cartItem) {
                    // If item exists, update its quantity to 1
                    updateCartItemQuantity(cartItem.key, 1);
                } else {
                    console.log('Product not in cart');
                }
            })
            .catch(error => {
                console.error('Error fetching cart:', error);
            });
    }

    // Attach a click event listener to elements with a specific class or ID
    document.querySelectorAll('[data-id]').forEach(element => {
        element.addEventListener('DOMContentLoaded', function () {
            const productId = this.getAttribute('data-id'); // Get product ID from the clicked element
            checkAndUpdateCart(productId);
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
  var qty_input = jQuery('.product-form__quantity');
  var productInfoWrapper = qty_input.closest('.product__info-wrapper');
  var buyButton = productInfoWrapper.find('.buy-button');
  var productForm = buyButton.find('product-form form');
  var productForm = productInfoWrapper.find('product-form form');

  if (qty_input.length > 0 && productForm.length > 0) {
    buyButton.addClass('qty-moved')
    qty_input.prependTo(productForm); // moves it to the start of form
  }
})


document.addEventListener('DOMContentLoaded', function () {
  var qty_input = jQuery('.product-form__quantity');
  var productInfoWrapper = qty_input.closest('.product__info-wrapper');
  var buyButton = productInfoWrapper.find('.buy-button');
  var productForm = buyButton.find('product-form form');
  var productForm = productInfoWrapper.find('product-form form');

  if (qty_input.length > 0 && productForm.length > 0) {
    buyButton.addClass('qty-moved')
    qty_input.prependTo(productForm); // moves it to the start of form
  }
})

function formatMoney(cents) {
  const locale = window.Shopify?.locale || 'en-US';
  const currency = window.Shopify?.currency?.active || 'USD';

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',   // "$250.00"
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  // Shopify prices are in cents
  const amount = cents / 100;

  return `${formatter.format(amount)} ${currency}`;
}

function isGiftCardVariant(variant) {
  return (
    variant &&
    variant.requires_shipping === false &&
    variant.inventory_management === null
  );
}


document.addEventListener('custom-variant:change', (event) => {
  const { variant, productForm } = event.detail;
  if (!variant || !productForm) return;

  updatePriceBlock(productForm, variant);
});

function updatePriceBlock(productForm, variant) {
  const priceRoot = productForm.querySelector('.price');
  if (!priceRoot) return;

  const regularPrice = priceRoot.querySelector(
    '.price__regular .price-item--regular'
  );
  const saleWrapper = priceRoot.querySelector('.price__sale');
  const salePrice = priceRoot.querySelector(
    '.price__sale .price-item--sale'
  );
  const comparePrice = priceRoot.querySelector(
    '.price__sale s.price-item--regular'
  );

  const sizeLabel = priceRoot.querySelector('.option_size');

  const priceHtml = formatMoney(variant.price);
  const compareHtml = variant.compare_at_price
    ? formatMoney(variant.compare_at_price)
    : null;

  // ─────────────────────────
  // SALE PRICE
  // ─────────────────────────
  if (compareHtml && variant.compare_at_price > variant.price) {
    priceRoot.classList.add('price--on-sale');

    if (salePrice) salePrice.innerHTML = priceHtml;
    if (comparePrice) comparePrice.innerHTML = compareHtml;

    if (saleWrapper) saleWrapper.style.display = '';
    if (regularPrice) regularPrice.closest('.price__regular').style.display = 'none';
  }
  // ─────────────────────────
  // REGULAR PRICE
  // ─────────────────────────
  else {
    priceRoot.classList.remove('price--on-sale');

    if (regularPrice) {
      regularPrice.innerHTML = `
        ${priceHtml}
      `;
    }

    if (saleWrapper) saleWrapper.style.display = 'none';
    if (regularPrice) regularPrice.closest('.price__regular').style.display = '';
  }

  // ─────────────────────────
  // SIZE LABEL (below price)
  // ─────────────────────────
  if (sizeLabel && !isGiftCardVariant(variant)) {
    sizeLabel.textContent = '/ ' + variant.public_title || '';
  }
}
